import React, { useState, useEffect } from 'react';
import styles from './tags.module.scss';
import WeeklySold from './weeklySold';
import RemainCount from './remainCount';
import { ProductCardProps } from '.';
import { getRemainingCount } from '@/utils/common/product-card';

export default function Tags(props: Partial<ProductCardProps>) {
  const { showAllTags = false, showActivity, showLeft = true, showWeekly, data, showSoldBy } = props;
  const [showRemainCount, setShowRemainCount] = useState<boolean>(false);
  const [showWeeklySold, setShowWeeklySold] = useState<boolean>(false);
  useEffect(() => {
    if (showAllTags) {
      setShowRemainCount(true);
      setShowWeeklySold(true);
      return;
    }
    //可以展示的标签个数
    let length = showSoldBy && !!data?.vender_info_view?.delivery_desc ? 1 : 2;
    if (showLeft) {
      const remainCount = getRemainingCount(data);
      if (remainCount > 0) {
        setShowRemainCount(true);
        length--;
        if (length === 0) {
          return;
        }
      }
    }
    if (showWeekly) {
      const weekSoldCount = data?.sold_count_ui !== '0' ? data?.sold_count_ui : '';
      if (weekSoldCount) {
        setShowWeeklySold(true);
        length--;
        if (length === 0) {
          return;
        }
      }
    }
  }, [showAllTags, showActivity, showLeft, showWeekly, data, showSoldBy]);

  return (
    <div className={styles.productCardTags}>
      {!showAllTags && showRemainCount && <RemainCount {...props} />}
      {showAllTags && showRemainCount && <RemainCount {...props} />}
      {showWeeklySold && <WeeklySold {...props} />}
    </div>
  );
}
